module.exports = __webpack_public_path__ + "static/media/bw.d9e5e45f.svg";